module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Snowfall-S2.8655867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Snowfall-S2.jpg
// module id = BoIR
// module chunks = 0